import { REDUX_ACTIONS } from 'utils/constants';
import { OrgUsers, Organizations } from 'utils/gloo-types';
import { FirebaseUser } from 'utils/firebase';
import { UserCredential } from 'firebase/auth';

export interface AuthState {
  isLoggedIn: boolean;
  isLoggedInWithoutAccount: boolean;
  user: FirebaseUser | null;
  userCredential: UserCredential | null;
  token: string | null;
  orgUser: OrgUsers | null;
  organization: Organizations | null;
  accessOrgs: Partial<Organizations>[];
  deviceData?: {
    user_agent?: string;
    device_country_code?: string;
    device_country_name?: string;
    device_city?: string;
    device_postal?: string;
    device_state?: string;
  };
}
export const initialState: AuthState = {
  isLoggedIn: false,
  isLoggedInWithoutAccount: false,
  user: null,
  userCredential: null,
  token: null,
  orgUser: null,
  organization: null,
  accessOrgs: [],
  deviceData: null,
};

export default function authReducer(state = initialState, action: any): AuthState {
  switch (action.type) {
    case REDUX_ACTIONS.LOGIN: {
      return {
        ...state,
        isLoggedIn: true,
        isLoggedInWithoutAccount: false,
        user: action.user,
        token: action.token,
        orgUser: action.orgUser,
        organization: action.organization,
        accessOrgs: action.accessOrgs || [],
      };
    }
    case REDUX_ACTIONS.LOGIN_WITHOUT_ACCOUNT: {
      return {
        ...state,
        isLoggedIn: false,
        isLoggedInWithoutAccount: true,
        user: action.user,
        userCredential: action.userCredential,
        token: action.token,
      };
    }
    case REDUX_ACTIONS.UPDATE_FIREBASE_USER:
      return { ...state, user: action.user, token: action.token };
    case REDUX_ACTIONS.UPDATE_ME:
      return {
        ...state,
        orgUser: action.orgUser,
        organization: action.organization,
        accessOrgs: action.accessOrgs || [],
        deviceData: action.deviceData,
      };
    case REDUX_ACTIONS.CHANGE_ORG:
      return { ...state, organization: action.organization };
    case REDUX_ACTIONS.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
